import { create } from 'zustand';
import { SessionState } from './session/state';
import { createUiSlice } from './session/ui.slice';
import { createActionsSlice } from './session/actions.slice';
import { createSessionSlice } from './session/session.slice';
import { createMarkdownEditorSlice } from './markdownEditorStore';

export const useSessionStore = create<SessionState>()((...a) => ({
  ...createSessionSlice(...a),
  ...createActionsSlice(...a),
  ...createUiSlice(...a),
  ...createMarkdownEditorSlice(...a),
}));